export type RawRecommendation = Record<string, unknown>

export enum ConnectionStatus {
  Connected = 'connected',
  Sending = 'sending',
  Error = 'error',
  Disconnected = 'disconnected',
}

export enum ChatMode {
  CHAT = 'CHAT',
  PRODUCT_DETAILS = 'PRODUCT_DETAILS',
  ERROR_SCREEN = 'ERROR_SCREEN',
  LOADING_CONVERSATION = 'LOADING_CONVERSATION',
}

export type ModelResponse = {
  response?: string
  follow_up_question?: string
  suggested_replies?: unknown[]
  support_url?: string
  recommendations?: RawRecommendation[]
}

export type ChatResponsePayload = {
  error?: string
  sessionId?: string
  runtimeSessionId?: string
  agentResponse?: unknown
  messages?: unknown[]
  restored?: boolean
  messageCount?: number
  metadata?: Record<string, unknown>
}
